export const ERRORS = {
  NotAuthorizedException: 'Your email and password do not match. Please try again',
  IncorrectEmail: 'Sorry, only letters (a-z), numbers (0-9), and periods (.) are allowed.',
  IncorrectPassword: 'Password must contain more than 6 characters, please try again.',
  NoPermission:
    'Sorry, you have no permission to access this site. Please contact Support Team for any concerns.',
};
